import { observable, action, makeObservable } from 'mobx';
import { setNewDate } from '../../utils/dateUtils';
import { InputType, ISelectValueType, ValueType } from './types';

export class DateInput implements InputType {
  dataType: 'datetime';

  label: string;

  tag: string;

  required: boolean;

  placeholder?: string;

  @observable value: Date | undefined | null;

  @observable selectorValue: ValueType<ISelectValueType> | undefined;

  error: string;

  disabled: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
  }: InputType) {
    if (dataType !== 'datetime')
      throw Error(
        `Type mismatch. Type must be of "datetime", instead saw "${dataType}"`,
      );
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(null, true); // set initial value
  }

  @action
  onChange = (v: Date | undefined | null, isDate: boolean) => {
    if (!v) {
      this.value = v;
    } else if (Number.isNaN(v.getTime())) {
      this.value = v;
    } else if (typeof this.value === 'string') {
      this.value = setNewDate(new Date(this.value), v, isDate);
    } else {
      this.value = setNewDate(this.value, v, isDate);
    }
  };

  @action
  clearValue = () => {
    this.value = null;
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
